import React from 'react'
import PropTypes from 'prop-types'
import {
    getUserData,
    isAuthenticated,
    subscribe,
    unsubscribe,
    setAccessToken,
    getAccessToken,
    setRefreshToken, setUserData, setTimeExp, setRoles
} from "../services/AuthServices"
import queryString from "query-string"
import {parseJwt} from './parseToken'

class WithAuthentication extends React.Component {
    constructor(props) {
        super(props)

        const {history} = this.props
        const {location} = history

        if (location.search !== '' || location.hash !== '') {
            const params = {
                ...queryString.parse(location.search),
                ...queryString.parse(location.hash)
            }
            const accessTokenOld = getAccessToken()
            let tokenSaved = false

            if (params.token && !accessTokenOld) {
                setAccessToken(params.token)
                const timeExp = parseJwt(params.token).exp - parseJwt(params.token).iat
                setUserData(parseJwt(params.token).permissions)
                setRoles(parseJwt(params.token).roles)
                setTimeExp((timeExp - 300)*1000 + new Date().getTime())
                tokenSaved = true
            }

            if (params.refresh) {
                setRefreshToken(params.refresh)
            }

            if (params.token || params.refresh) {
                if (tokenSaved) {
                    window.location.href = location.pathname
                } else {
                    window.history.replaceState({}, '', location.pathname)
                }
            }
        }

        this.state = {
            isAuthenticated: isAuthenticated(),
            user: getUserData()
        }
    }

    componentDidMount() {
        subscribe(this._handleAuthChange)
    }

    componentWillUnmount() {
        unsubscribe(this._handleAuthChange)
    }

    _handleAuthChange = () => {
        this.setState({
            isAuthenticated: isAuthenticated(),
            user: getUserData()
        })
    }

    render() {
        return this.props.children(this.state)
    }
}

WithAuthentication.propTypes = {
    children: PropTypes.func.isRequired,
}

export default WithAuthentication
